<template lang="pug">
    div
        regular-button(:loading="loading" @click="onOpen" :value="BUTTONS_VALUES.get_sms_balance" color="green")
        modal(name="sms-balance" :height="200")
            .p-2.h-full 
                .p-4.bg-gray-100.h-full
                    .text-2xl.mb-4 SMS баланс
                    template(v-if="balance && balance.length")
                        ul
                            li.text-sm.mb-2 Тип баланса: {{balance[0]}}
                            li.text-sm.mb-2 Остаток: {{balance[1]}}
                            li.text-sm Кредит: {{balance[2]}}
</template>

<script>
//Components
import RegularButton from '@/components/common/buttons/regular-button';
//Config
import { BUTTONS_VALUES } from '@/configs/names';
import { ICONS } from '@/configs/icons';
//Store
import { SMSNameSpace, SMSActionTypes, SMSGetterTypes } from '@/store/sms/types';
//Mixins
import { _openModal_, _closeModal_ } from '@/mixins/modals';

export default {
    name: "GetSMSBalanceComponent",
    mixins: [_openModal_, _closeModal_],
    components: {
        'regular-button': RegularButton,
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        BUTTONS_VALUES() {
            return BUTTONS_VALUES
        },
        ICONS() {
            return ICONS
        },
        balance() {
            return this.$store.getters[`${SMSNameSpace}/${SMSGetterTypes.GetBalance}`]
        },
    },
    methods: {
        async onOpen() {
            if (this.loading) {
                return
            }
            this._openModal_({ name: 'sms-balance' })
            this.loading = true
            try {
                await this.$store.dispatch(`${SMSNameSpace}/${SMSActionTypes.GetBalance}`)
            } finally {
                this.loading = false
            }
        },
    }
}
</script>